import request from '@/utils/request'
import store from '@/store'
import {
	getToken
} from '@/utils/auth'

export function login(data) {
	return request({
		url: 'procurement/system/front/users/login/pc',
		method: 'POST',
		data: data,
		headers: {
			'content-type': 'application/x-www-form-urlencoded'
		}
	})
}

export function logout() {
	return request({
		url: 'procurement/system/front/users/logout',
		method: 'POST'
	})
}

/**
 * 2024年12月30日 qn
 * 获取业务员分组
 * */
export function getGroupTree() {
	let url = 'procurement/system/front/enterprise-groups/user-tree';

	return request({
		url: url,
		method: 'GET',
	})
}

/**
 * 2023年2月9日 qn
 * 提交业务员分组
 * */
export function salesmanGroup(groupId) {
	let url = 'procurement/system/front/enterprises/salesman/group/' + groupId;

	return request({
		url: url,
		method: "PUT",
	})
}